import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, Phone, Globe } from 'lucide-react';
import { Button } from '../ui/button';
import {
  Sheet,
  SheetContent,
  SheetTrigger,
  SheetTitle,
} from '../ui/sheet';
import { useLanguage } from '../../context/LanguageContext';
import * as mockFr from '../../data/mock';
import * as mockAr from '../../data/mock-ar';

const Header = () => {
  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation();
  const { language, toggleLanguage } = useLanguage();
  
  const data = language === 'ar' ? mockAr : mockFr;
  const { companyInfo, navigationLinks } = data;

  const isActive = (path) => location.pathname === path;

  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-[#1a1c1b]/95 backdrop-blur-md border-b border-white/10">
      <div className="container-custom">
        <div className="flex items-center justify-between h-20">
          {/* Logo */}
          <Link to="/" className="flex items-center gap-3">
            <img
              src={companyInfo.logo}
              alt="PREBATI"
              className="h-12 w-auto"
            />
          </Link>

          {/* Desktop Navigation */}
          <nav className="hidden lg:flex items-center gap-1">
            {navigationLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className={`px-4 py-2 text-sm font-medium transition-colors rounded-lg ${
                  isActive(link.path)
                    ? 'text-white bg-white/10'
                    : 'text-white/70 hover:text-white hover:bg-white/5'
                }`}
              >
                {link.name}
              </Link>
            ))}
          </nav>

          {/* Desktop CTA + Language Switcher */}
          <div className="hidden lg:flex items-center gap-4">
            {/* Language Switcher */}
            <button
              onClick={toggleLanguage}
              className="flex items-center gap-2 px-3 py-2 text-white/70 hover:text-white hover:bg-white/5 rounded-lg transition-colors"
              title={language === 'fr' ? 'العربية' : 'Français'}
            >
              <Globe className="w-4 h-4" />
              <span className="text-sm font-medium">{language === 'fr' ? 'AR' : 'FR'}</span>
            </button>
            
            <a
              href={`tel:${companyInfo.phone}`}
              className="flex items-center gap-2 text-white/70 hover:text-white text-sm transition-colors"
            >
              <Phone className="w-4 h-4" />
              {companyInfo.phone}
            </a>
            <a href="https://wa.me/22243111616?text=" target="_blank" rel="noopener noreferrer">
              <Button className="btn-primary">
                {language === 'ar' ? 'طلب عرض سعر' : 'Demander un devis'}
              </Button>
            </a>
          </div>

          {/* Mobile Menu */}
          <div className="lg:hidden flex items-center gap-2">
            {/* Mobile Language Switcher */}
            <button
              onClick={toggleLanguage}
              className="flex items-center justify-center w-10 h-10 text-white/70 hover:text-white hover:bg-white/5 rounded-lg transition-colors"
              title={language === 'fr' ? 'العربية' : 'Français'}
            >
              <Globe className="w-5 h-5" />
            </button>
            
            <Sheet open={isOpen} onOpenChange={setIsOpen}>
              <SheetTrigger asChild>
                <Button variant="ghost" size="icon" className="text-white">
                  <Menu className="w-6 h-6" />
                </Button>
              </SheetTrigger>
              <SheetContent side={language === 'ar' ? 'left' : 'right'} className="bg-[#1a1c1b] border-white/10 w-80">
                <SheetTitle className="text-white sr-only">Menu de navigation</SheetTitle>
                <div className="flex flex-col h-full pt-8">
                  <nav className="flex flex-col gap-2">
                    {navigationLinks.map((link) => (
                      <Link
                        key={link.path}
                        to={link.path}
                        onClick={() => setIsOpen(false)}
                        className={`px-4 py-3 text-base font-medium transition-colors rounded-lg ${
                          isActive(link.path)
                            ? 'text-white bg-white/10'
                            : 'text-white/70 hover:text-white hover:bg-white/5'
                        }`}
                      >
                        {link.name}
                      </Link>
                    ))}
                  </nav>
                  <div className="mt-8 pt-8 border-t border-white/10">
                    <a
                      href={`tel:${companyInfo.phone}`}
                      className="flex items-center gap-3 px-4 py-3 text-white/70 hover:text-white transition-colors"
                    >
                      <Phone className="w-5 h-5" />
                      {companyInfo.phone}
                    </a>
                    <a href="https://wa.me/22243111616?text=" target="_blank" rel="noopener noreferrer" onClick={() => setIsOpen(false)} className="block mt-4">
                      <Button className="btn-primary w-full">
                        {language === 'ar' ? 'طلب عرض سعر' : 'Demander un devis'}
                      </Button>
                    </a>
                  </div>
                </div>
              </SheetContent>
            </Sheet>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
